<div class="input-group validate-include-children">
	<input
		autocomplete="new-password"
		class="form-control squared-end"
		id="{{ id }}"
		[formControl]="ctrl"
		[placeholder]="placeholder"
		[required]="required"
		[title]="title"
		[type]="fieldType"
	/>
	@if (hidePassword) {
		<button
			class="btn btn-outline-secondary squared-all"
			type="button"
			[ngbTooltip]="
				fieldType === 'password' ? 'Show password' : 'Hide password'
			"
			(click)="toggleFieldType()"
		>
			<span class="screen-reader-text">{{
				fieldType === 'password' ? 'Show password' : 'Hide password'
			}}</span>
			<i
				class="far"
				[ngClass]="{
					'fa-eye': fieldType === 'text',
					'fa-eye-slash': fieldType === 'password',
				}"
			></i>
		</button>
	}
	<button
		class="btn btn-primary squared-start"
		ngbTooltip="Make me a random password"
		type="button"
		(click)="generatePassword()"
	>
		<span class="screen-reader-text">Make me a random password</span>
		<i class="fal fa-dice"></i>
	</button>
</div>
